/*
 * detectCSS
 * http://github.amexpub.com/modules/detectCSS
 *
 * Copyright (c) 2013 AmexPub. All rights reserved.
 */

module.exports = require('./lib/detectCSS');



// WEBPACK FOOTER //
// ./~/detectcss/index.js